import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reinicia el scroll al cambiar de ruta.
// Si la URL trae un ancla (#seccion), se desplaza a ese elemento.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // esperar a que el contenido de la ruta esté montado
      const id = hash.slice(1);
      const scrollToEl = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };
      if (scrollToEl()) return;
      const t = setTimeout(scrollToEl, 100);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
